import {
  ViewChild,
  OnInit,
  Input,
  Type,
  OnDestroy,
  Output,
  EventEmitter,
  Component,
  ViewEncapsulation,
  NgZone,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  HostListener,
} from "@angular/core";
import {
  HttpCommonService,
  AppTranslationService,
  AccountService,
  Utilities,
  GridFilter,
  PagingDataResult,
  CorrectYeKeService,
  AggregatesInfo,
} from "projects/sepidz-web-framework/src/lib/services";
import { form_control, Permission, EntityListAction, SaveReportFile } from "projects/sepidz-web-framework/src/lib/models";
import { ShowToastrService } from "projects/sepidz-web-framework/src/lib/services/show-toastr.service";
import { TabularService, ITab } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import {
  SelectAllCheckboxState,
  GridComponent,
  GridDataResult,
  DataStateChangeEvent,
  SelectionEvent,
  ColumnComponent,
  ScrollRequest,
} from "@progress/kendo-angular-grid";
import { CompositeFilterDescriptor, State, process, FilterDescriptor, SortDescriptor, GroupDescriptor } from "@progress/kendo-data-query";
import { Datatransfer, VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { Subject, of } from "rxjs";
import { ExcelExportData } from "@progress/kendo-angular-excel-export";
import { EntityBase, GridColumnInfo, GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { takeUntil, take, delay } from "rxjs/operators";
import { DomSanitizer, SafeStyle } from "@angular/platform-browser";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { StimulSoftReportComponent, ReportInfo } from "src/app/stimul-soft-report/stimul-soft-report.component";
import { ReportKind, RowState, SystemKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { ReportCopyComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-copy.component";
import { ReportSelectorComponent } from "./report-selector/report-selector.component";
import { Router } from "@angular/router";
import { ReportKindInfo } from "./report-kind";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { CommonService } from "../../../sepidz-web-framework/src/lib/services/common.service";
import { PageSizeItem } from "@progress/kendo-angular-grid";
import { AppInjector } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { PersianService } from "projects/sepidz-web-framework/src/lib/services/persian.service";
import { ColumnVisibilityChangeEvent } from "@progress/kendo-angular-treelist";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";

@Component({
  selector: "kgrid",
  templateUrl: "./kgrid.component.html",
  styleUrls: ["./kgrid.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [HttpCommonService, AppTranslationService, ShowToastrService, Datatransfer, SimpleModalService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KGridComponent implements OnInit, OnDestroy {
  @Input() isCopy: boolean = false;

  public pageSizes: PageSizeItem[] = [
    {
      text: "15",
      value: 15,
    },
    {
      text: "5",
      value: 5,
    },
    {
      text: "10",
      value: 10,
    },
    {
      text: "20",
      value: 20,
    },
    {
      text: "همه",
      value: "all",
    },
  ];
  ngUnsubscribe = new Subject<void>();
  _GridColumnInfo: GridColumnInfo;
  reportList: SaveReportFile[];
  @Input() SelectById: string = "Id";
  @Input() mySelection: number[] = [];
  @Input() hasBracketForNegativeValues = true;
  public selectAllState: SelectAllCheckboxState = "unchecked";
  loadAllData: boolean = false;
  public FormControlTypes = FormControlTypes;
  rowsCache: any[] = [];
  exportKind: string = "";
  selectedRows: any[] = [];
  dialogIsloaded: boolean = false;
  isRefreshing: boolean = false;
  refreshingTime: number = 0;
  isPageSizes: boolean = true;
  buttonCount: number = 5;
  showExitDiv: boolean;
  isShowExit: boolean;
  isShowExitPrint: boolean;
  hasAccessToExcel = true;
  @Input() editFromForm: boolean = false;
  @Input() isHeaderSave: boolean = false;
  @Input() unSortableFilterable: string[] = [];
  @Input() unSortableFilterableAll: boolean = false;
  public type: "numeric" | "input" = "numeric";
  public gridView: GridDataResult;
  @Input() groups: GroupDescriptor[] = [];
  public state: State = {
    skip: 0,
    take: 15,
    filter: {
      logic: "and",
      filters: [],
    },
    group: [],
  };
  @Input() filterText: string;
  @Input() actionTregger: (
    action: EntityListAction,
    onRowSelected: any,
    onRowsSelected: any[],
    isAllSelected: boolean,
    gridFilter: GridFilter[]
  ) => void;
  @Input() filtering: boolean = true;
  @Input() allowUnsort: boolean = true;
  @Input() hasColumnMenu: boolean = true;
  @Input() hasReport: boolean = true;
  @Input() hasRefresh: boolean = true;
  @Input() gridName: string;
  @Input() customExportExcelUrl: string = null;
  @Input() getParamsForExportExcelWithPostMethod: () => Promise<any> = () =>
    new Promise((resolve) => {
      resolve(true);
    });

  @Input() set filters(value: GridFilter[]) {
    if (this._filters !== value) {
      this._filters = value;
      if (!this.isRefreshing) this.refreshData();
    }
  }
  get filters(): GridFilter[] {
    return this._filters;
  }
  _filters: GridFilter[];
  @Input() gridHeight: number = 100;
  @Input() VoucherKindIdName: string;
  @Input() VoucherKindId: number;
  @Input() pagingSize: number = 15;
  @Input() noToolBar: boolean = false;
  @Input() useCustomDelete: boolean = false;
  @Input() hideToolber: boolean = false;
  @Input() paging: boolean = true;
  @Input() filtrableFields: string = "";
  @Input() isAdd: boolean = true;
  @Input() isEdit: boolean = true;
  @Input() isVisible: boolean = false;
  @Input() isDelete: boolean = true;
  @Input() isMultiDelete: boolean = false;
  @Input() isMulti: boolean = false;
  @Input() isModal: boolean = true;
  @Input() groupable: boolean = true;
  @Input() isHideFooter: boolean = false;
  @Input() noAutoFitColumns: boolean = false;
  @Input() notLoadData: boolean = false;
  @Input() name: string;
  @Input() showLoadingMessage = true;
  @Input() label: string;
  @Input() apiName: string;
  @Input() pathPreFix: string;
  @Input() areaName: string;
  @Input() systemName: string;
  @Input() category: string;
  _columns: form_control[] = [];
  @Input() set columns(value: form_control[]) {
    this._columns = value;
    this.setColumnWidth();
    this.cd.markForCheck();
  }
  get columns(): form_control[] {
    return this._columns;
  }

  @Input() inputEditorform: Type<any>;

  @Input() aggregatesColumnName?: string;
  @Input() actions: any[];
  _dataList: any[];
  @Input() get dataList(): any[] {
    return this._dataList;
  }
  set dataList(value: any[]) {
    this._dataList = value;
    if (!this._dataList) this._dataList = [];
    if (this._dataList["Data"]) {
      this.gridView.data = this._dataList["Data"];
      this.gridView.total = this._dataList["TotalPage"];
      this.isRefreshing = false;
      setTimeout(() => this.cd.markForCheck(), 100);
      return;
    }
    if (!this.paging) {
      if (!this.gridView)
        this.gridView = process(this._dataList.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached) as any[], {
          group: this.state.group,
          sort: this.state.sort,
          filter: this.state.filter,
        });

      this.gridView.data = this._dataList.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached) as any[];
      this.gridView.total = (this._dataList.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached) as any[]).length;
      this.isRefreshing = false;
      this.setGridData();
      if (this.grid && (!this.noAutoFitColumns || this.commonService.isMobileMode))
        setTimeout(
          () =>
            this.ngZone.onStable
              .asObservable()
              .pipe(take(1))
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(() => {
                this.grid?.autoFitColumns();
              }),
          100
        );
    } else if (this._dataList !== undefined) {
      this.gridView = process(this._dataList.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached) as any[], {
        group: this.state.group,
        sort: this.state.sort,
        filter: this.state.filter,
      });
      this.gridView.total = this.gridView.data.length;
      this.isRefreshing = false;
      setTimeout(() => this.cd.markForCheck(), 100);
    }
    setTimeout(() => this.refreshData(), 100);
  }

  modalIsLoaded: boolean = false;
  currentReport: string = "print";
  filteredList: any;
  aggregatesInfo: AggregatesInfo[];
  @HostListener("window:keydown", ["$event"])
  cs(e: KeyboardEvent) {
    if (document.hidden) return;

    if (e.ctrlKey && e.shiftKey && !e.altKey && (e.key.toUpperCase() === "P" || e.key === "ح" || e.key === "\\")) {
      e.preventDefault();
      this.currentReport = "preview";
      this.changeReport("preview");
    }
    if (e.ctrlKey && e.altKey && !e.shiftKey && (e.key.toUpperCase() === "P" || e.key === "ح")) {
      e.preventDefault();
      this.currentReport = "editReport";
      this.changeReport("editReport");
    }
    if (e.ctrlKey && !e.altKey && !e.shiftKey && (e.key.toUpperCase() === "P" || e.key === "ح")) {
      e.preventDefault();
      this.currentReport = "print";
      this.changeReport("print");
    }
  }
  _gridViewData: PagingDataResult<any>;
  @Input() set gridViewData(value: PagingDataResult<any>) {
    this._gridViewData = value;
    if (this._gridViewData && this._gridViewData.Data !== undefined && this._gridViewData.Data !== null) {
      this.gridView = process(this._gridViewData.Data as any[], { group: this.state.group, sort: this.state.sort, filter: this.state.filter });
      this.gridView.total = this._gridViewData.TotalPage;
      this.isRefreshing = false;
      this.setGridData();
      this.fitColumns();
      setTimeout(() => {
        this.cd.markForCheck();
        if (this._gridViewData.Data && this.grid.data["total"] !== this._gridViewData.TotalPage)
          this.grid.data["total"] = this._gridViewData.TotalPage;
        if ((this._gridViewData.Data && !this.grid.data["data"]) || this.grid.data["data"].length <= 0)
          this.grid.data["data"] = this._gridViewData.Data;
        if (
          this._gridViewData &&
          this._gridViewData.Data &&
          this._gridViewData.TotalPage > 0 &&
          this.grid &&
          (!this.grid.data["total"] || this.grid.data["total"] <= 0 || this.grid.data["total"] < this.gridView.total)
        ) {
          this.gridViewData = this._gridViewData;
        }
      }, 50);
    }
    this.cd.markForCheck();
  }
  _defaultFilterKey: NameValue[];
  @Input() disableOnDoubleClick: boolean = false;
  @Input() IgnoreDeletePermission: boolean = false;
  @Input() deleteMessage: string = "";
  @Input() onlyDefaultSortKey: boolean = false;
  @Input() defaultSortKey: string;
  @Input() defaultSortKeyKind: "asc" | "desc" = "desc";
  @Input() set defaultFilterKey(value: NameValue[]) {
    this._defaultFilterKey = value;
    this.setDefaultFilterKey();
  }
  get defaultFilterKey() {
    return this._defaultFilterKey;
  }
  @Input() editorModal: any;
  @Input() reportName: string;
  @Input() icon?: string;
  @Output() onSave = new EventEmitter();
  @Output() onRefreshData = new EventEmitter<any>();
  @Output() onDataStateChanged = new EventEmitter<GridFilter[]>();
  @Output() onCreate = new EventEmitter<any>();
  @Output() onEdit = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();
  @Output() onRowSelected = new EventEmitter<any>();
  @Output() onRowsSelected = new EventEmitter<any[]>();
  @Output() onDoubleClick = new EventEmitter<any>();
  @Output() onGetDataComplete = new EventEmitter<any>();
  @Output() onDeleteCompleted = new EventEmitter<boolean>();

  firsTtotalCountDeferent: boolean = true;
  editingName: { name: string };
  SelectRow: any;
  filter: CompositeFilterDescriptor;

  public allData(): ExcelExportData {
    let data: any[];
    if (this.selectedRows.length > 0) data = this.selectedRows;
    else data = process(this.gridView.data, { group: this.state.group, sort: this.state.sort }).data;
    const result: ExcelExportData = { data, group: this.state.group };
    return result;
  }
  reportKinds = ReportKindInfo.reportKinds;
  @ViewChild(GridComponent)
  public grid: GridComponent;
  isFocusted: boolean;
  isFirstLoad: boolean;
  // static _dialogService: SimpleModalService;
  private dialogService: SimpleModalService;
  validActions: any[];
  constructor(
    public missetup: MisSetupService,
    public commonService: CommonService,
    private router: Router,
    private sts: ShowToastrService,
    private _httpCommonService: HttpCommonService,
    private accountService: AccountService,
    private ngZone: NgZone,
    private cd: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private tabsservice: TabularService,
    private persianService: PersianService,
    private splashFormService: SplashFormService
  ) {
    this.allData = this.allData.bind(this);
    this.dialogService = AppInjector.get(SimpleModalService);
  }
  replaceDigits() {
    var map = ["&#1632;", "&#1633;", "&#1634;", "&#1635;", "&#1636;", "&#1637;", "&#1638;", "&#1639;", "&#1640;", "&#1641;"];

    document.getElementById("kGrid").innerHTML = document.getElementById("kGrid").innerHTML.replace(/\d(?=[^<>]*(<|$))/g, function ($0) {
      return map[$0];
    });
  }
  ngOnInit() {
    this.state.take = this.pagingSize;
    this.state.group = this.groups;
    if (this.isAdd && this.apiName)
      this.isAdd = this.accountService.userHasPermission(`${this.areaName}:${this.apiName.split("/")[0]}`, Permission.createPermission);
    if (this.isEdit && this.apiName)
      this.isEdit = this.accountService.userHasPermission(`${this.areaName}:${this.apiName.split("/")[0]}`, Permission.editPermission);
    if (this.isVisible && this.apiName)
      this.isVisible = this.accountService.userHasPermission(`${this.areaName}:${this.apiName.split("/")[0]}`, Permission.editPermission);
    if (this.isDelete && this.apiName)
      this.isDelete = this.accountService.userHasPermission(`${this.areaName}:${this.apiName.split("/")[0]}`, Permission.deletePermission);
    this.setDefaultSortKey();

    this.loadReports();
    this.setDefaultFilterKey();
    if (!this.columns || this.columns.length <= 0) this.setColumns();
    else {
      this.setColumnWidth();
      this.refreshData();
    }
    this.tabsservice.tabItemonRefreshData.next("");
    this.tabsservice.tabItemonRefreshData.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      if (x && x === this.apiName) {
        this.loadReports();
        this.refresh_Data();
      }
    });
    this.setvalidactions();
    this.checkAccessToExcel();
  }
  checkAccessToExcel() {
    const controllerName = this.apiName?.split("/") ? this.apiName?.split("/")[0] : null;
    this.hasAccessToExcel = !!this.accountService.userHasPermission(`${this.areaName}:${controllerName}`, `ExcelAccess`);
  }

  setDefaultFilterKey() {
    if (this.defaultFilterKey) {
      if (!this.state.filter.filters) this.state.filter.filters = [];
      this.defaultFilterKey.forEach((x) => {
        if (!this.state.filter.filters.some((f) => f["field"] === this.getmodelName(x.Name))) {
          this.state.filter.filters.push({
            logic: "and",
            field: this.getmodelName(x.Name),
            operator: !x.Operator ? "eq" : x.Operator,
            value: x.Value,
          });
        } else this.state.filter.filters.find((f) => f["field"] === this.getmodelName(x.Name))["value"] = x.Value;
      });
    }
  }
  setDefaultSortKey() {
    if (this.defaultSortKey) {
      var keys = this.defaultSortKey?.split(",");
      if (!this.state.sort) this.state.sort = [];
      keys.forEach((x) => {
        if (!this.state.sort.some((f) => f["field"] === x)) {
          this.state.sort.push({
            field: `${x}`,
            dir: this.defaultSortKeyKind,
          });
        }
      });
    }
  }
  removeDefaultSortKey() {
    if (this.defaultSortKey != undefined && this.defaultSortKey.length > 0) {
      var keys = this.defaultSortKey?.split(",");
      if (this.state.sort.length <= keys.length) return;
      var sort: SortDescriptor[] = [];
      this.state.sort.forEach((x) => {
        if (!keys.some((s) => s === x.field))
          sort.push({
            field: x.field,
            dir: x.dir,
          });
      });
      this.state.sort = sort;
      if (!this.state.sort || this.state.sort.length === 0) this.setDefaultSortKey();
    }
  }
  async loadReports() {
    if (!this.apiName || !this.hasReport) return;
    if (!this.pathPreFix) this.pathPreFix = "GNR";
    const data = await this._httpCommonService
      .getList(this.apiName?.split("/")[0] + "/GetReportInfo/" + this.pathPreFix + "/" + this.apiName.replace("/", "_"))
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise();
    if (data) {
      this.reportList = data as [];
    }
  }
  async setColumns() {
    if (!this.apiName) return;
    const data = await this._httpCommonService
      .getControlsList(this.apiName.split("/")[0])
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          if (data) {
            this.columns = (data as form_control[]).sort((a, b) => a.order - b.order);
            this.setColumnWidth();
            this.refreshData();
          }
        },
        (error) => console.log(error)
      );
  }

  setColumnWidth() {
    if (!this.columns) return;
    this.columns.forEach((x) => {
      if (
        x.textType === "number" &&
        x.withComma &&
        !x.name.toUpperCase().includes("NUMBER") &&
        !x.name.toUpperCase().includes("CODE") &&
        !x.name.toUpperCase().includes(".ID")
      ) {
        if (this.hasBracketForNegativeValues) {
          x.format = "#,#.#####;(#,#.#####)";
        }
        x.format = "#,#.#####";
      } else x.format = "";
      if (!x.columnWidth || x.columnWidth <= 100) {
        if (x.textType === "text") x.columnWidth = 200;
        else x.columnWidth = 100;
      }
    });
  }
  setGridData() {
    if (this.grid && (this.grid.data != this.gridView.data || this.grid.data["total"].length !== this.gridView.total)) {
      this.grid.data = this.gridView.data;
      this.grid.data["total"] = this.gridView.total;
    } else if (!this.grid)
      setTimeout(() => {
        this.setGridData();
      }, 100);
    if (this.apiName === "Company") {
      this.isAdd = this.gridView.data.length <= 0;
    }
  }
  refresh_Data() {
    this.onRefreshData.emit();
    this.refreshData();
  }
  async refreshData() {
    this.refreshingTime = 0;
    this.modalIsLoaded = false;
    this.setDefaultSortKey();
    this.SelectRow = null;
    this.mySelection = [];
    this.selectedRows = [];
    if (this._gridViewData !== undefined) {
      if (!this.isRefreshing) this.onDataStateChanged.emit(this.getGridFilter());
    } else if ((this.dataList && this.dataList?.length > 0) || this.noToolBar) {
      const data = (this.dataList?.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached) as any[]) || [];
      this.gridView = process(data, { group: this.state.group, sort: this.state.sort, filter: this.state.filter });
      this.gridView.total = data.length;
      if (this.gridView.data.length <= 0) this.gridView.data = data;
      this.setGridData();
      this.isRefreshing = false;
      this.fitColumns();
      setTimeout(() => this.cd.markForCheck(), 100);
    } else {
      if (this.paging && this.apiName !== undefined && this.notLoadData !== true) {
        if (
          this.defaultSortKey ||
          this._filters ||
          (this.state.filter.filters && this.state.filter.filters.length > 0) ||
          (this.apiName && this.apiName?.split("/")?.length > 1)
        )
          this.filterChange();
        else this.loadItems();
      } else {
        if (this.systemName && this.category) {
          if (this.showLoadingMessage) this.sts.showToast("primary", "", "در حال بارگذاری اطلاعات...");

          this.isRefreshing = true;
          await this._httpCommonService
            .getLookupByCategory(this.apiName, this.systemName, this.category)
            .pipe(takeUntil(this.ngUnsubscribe))
            .toPromise()
            .then(
              (data) => {
                if (data !== undefined) {
                  this.gridView = process(data as any[], { group: this.state.group, sort: this.state.sort, filter: this.state.filter });
                  this.gridView.total = (data as any[]).length;
                  if (this.gridView.data.length <= 0) this.gridView.data = data as any[];
                  this.onGetDataComplete.emit(data);
                }
                this.setGridData();
                this.sts.showToast("success", "", "اطلاعات با موفقیت بارگذاری شد.");
                this.isRefreshing = false;
                this.fitColumns();
                this.cd.markForCheck();
              },
              (error) => {
                this.isRefreshing = false;
                this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در حذف اطلاعات");
              }
            );
        } else {
          if (this.showLoadingMessage) this.sts.showToast("primary", "", "در حال بارگذاری اطلاعات...");
          if (!this.apiName) return;
          this.isRefreshing = true;
          await this._httpCommonService
            .getList(this.apiName)
            .pipe(takeUntil(this.ngUnsubscribe))
            .toPromise()
            .then(
              (data) => {
                if (data !== undefined) {
                  this.gridView = process(data as any[], { group: this.state.group, sort: this.state.sort, filter: this.state.filter });
                  this.gridView.total = (data as any[]).length;
                  if (this.gridView.data.length <= 0) this.gridView.data = data as any[];
                }
                this.setGridData();
                this.sts.showToast("success", "", "اطلاعات با موفقیت بارگذاری شد.");
                this.isRefreshing = false;
                this.fitColumns();
              },
              (error) => {
                this.isRefreshing = false;
                this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در حذف اطلاعات");
              }
            );
        }
      }
    }

    this.setvalidactions();
  }
  setSelectedRows(e: any, items: any[]) {
    if (!this.selectedRows) this.selectedRows = [];
    items.forEach((x) => {
      if (x.items) this.setSelectedRows(e, x.items);
      else if (!this.selectedRows.some((s) => s["Id"] === x["Id"])) this.selectedRows.push(x);
    });
  }
  setvalidactions() {
    if (!this.actions) return this.actions;
    var list = this.actions.filter(
      (x) =>
        x.permission === true ||
        this.accountService.userHasPermission(`${x.areaName}:${x.apiName}`, x.permission ? x.permission : Permission.managePermission)
    );
    this.validActions = list;
    this.cd.markForCheck();
  }
  public onSelectedKeysChange(e) {
    const len = e.length;
    if (len === 0) {
      this.selectAllState = "unchecked";
    } else if (len > 0 && len < this.gridView.total) {
      this.selectAllState = "indeterminate";
    } else {
      this.selectAllState = "checked";
    }
    if (this.isMulti) {
      if (e && e.length > 0) {
        if (this.gridView.data[0].items) this.setSelectedRows(e, this.gridView.data[0].items);
        else this.selectedRows = this.gridView.data.filter((x) => e.some((s) => s === x.Id));
      } else this.selectedRows = [];
    }
    if (this.isMulti) {
      if (this.mySelection && this.mySelection.length > 0) {
        if (this.selectedRows && this.selectedRows.length > 0)
          this.selectedRows = this.selectedRows.filter((x) => this.mySelection.some((s) => s === x.Id));
        else this.selectedRows = [];
      }
      this.onRowsSelected.emit(this.selectedRows);
    }
  }
  public onSelectAllChange(checkedState: SelectAllCheckboxState) {
    if (checkedState === "unchecked" && this.mySelection.length <= 0) {
      this.mySelection = this.gridView.data.map((item) => item.Id);
      this.onSelectedKeysChange(this.mySelection);
    }
    if (checkedState === "checked") {
      this.mySelection = this.gridView.data.map((item) => item.Id);
      this.selectAllState = "checked";
    } else {
      this.mySelection = [];
      this.selectAllState = "unchecked";
    }
  }
  setColumnInfo(columnInfos: GridColumnInfoDetail[]) {
    if (!this.grid)
      setTimeout(() => {
        this.setColumnInfo(columnInfos);
      }, 50);

    if (this.grid?.columns) {
      if (this.grid.columns.length <= 1) {
        setTimeout(() => this.setColumnInfo(columnInfos), 200);
      }
    }
    if (this.grid?.columns) {
      this.grid.columns.forEach((x: ColumnComponent) => {
        const column = columnInfos.find((c) => c.name === (x.field ?? x.title));
        if (column) {
          x.leafIndex = column.leaftindex;
          x.orderIndex = column.orderindex;
          x.minResizableWidth = column.minResizableWidth;
          x.width = column.width;
          x.hidden = column.hidden;
        }
      });
    }
    this.isFirstLoad = true;
    this.cd.detectChanges();
    // هماهنگی با مهندس صفایی
    //this.grid?.focus();
    setTimeout(() => {
      const firstCol: ScrollRequest = {};
      firstCol.column = 0;
      if (this.grid && firstCol) this.grid?.scrollTo(firstCol);
    }, 110);
  }
  setDefaultColumnInfo() {
    this.grid?.columns?.forEach((x: ColumnComponent) => {
      if (x.title === "عملیات") {
        x.width = 70;
        x.minResizableWidth = 60;
        x.leafIndex = undefined;
        x.orderIndex = 0;
      }
      if (!x.title && !x.field) {
        x.width = x.width;
        x.minResizableWidth = x.minResizableWidth;
        x.leafIndex = undefined;
        x.orderIndex = 0;
      }
      const column = this.columns.find((c) => c.name === (x.field ?? x.title));
      if (column) {
        x.width = column.columnWidth;
        x.minResizableWidth = x.minResizableWidth;
        x.hidden = !column.listVisible;

        x.leafIndex = undefined;
        x.orderIndex = 0;
      }
    });
    this.cd.markForCheck();
    // هماهنگی با مهندس صفایی
    //this.grid?.focus();
    this.refreshData();
  }
  async fitColumns() {
    if (this.VoucherKindId < 0) this.VoucherKindId = this.VoucherKindId * -1;
    if (!this.isFirstLoad) {
      if (this._GridColumnInfo) {
        let columnInfos: GridColumnInfoDetail[] = JSON.parse(this._GridColumnInfo.ColumnInfo);
        this.setColumnInfo(columnInfos);
      } else if (this.name) {
        const x = await this._httpCommonService
          .get(
            "MisSetUp/GetGridColumnInfo/?key=" +
              (this.VoucherKindId ? `${this.name}_${this.VoucherKindId}` : this.name) +
              `&CreatedUserId=${this.accountService.authService.currentUser.Id}`
          )
          .pipe(takeUntil(this.ngUnsubscribe))
          .toPromise();
        if (x) {
          this._GridColumnInfo = x as GridColumnInfo;
          this.setColumnInfo(JSON.parse(x["ColumnInfo"]));
          if (this._GridColumnInfo.Group) {
            this.state.group = JSON.parse(x["Group"]);
            setTimeout(() => this.refreshData(), 100);
          }
        } else if (this.noAutoFitColumns) this.setDefaultColumnInfo();

        this.isFirstLoad = true;
      }
    }
    setTimeout(
      () => {
        this.cd.detectChanges();
        this.cd.markForCheck();
      },
      this.isFirstLoad ? 500 : 200
    );

    this.cd.markForCheck();
  }

  async loadItems() {
    if (this.isRefreshing || !this.apiName) return;
    this.isRefreshing = true;
    await this._httpCommonService
      .GetPagining<PagingDataResult<any>>(
        this.apiName + "/GetPagining",
        this.filtrableFields,
        "",
        this.loadAllData ? 0 : this.state.skip,
        this.loadAllData ? 0 : this.state.take
        // this.state.SortColumn
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (x) => {
          this.gridView = process(x.Data as any[], { group: this.state.group, sort: this.state.sort, filter: this.state.filter });
          this.gridView.total = x.TotalPage;
          if (this.gridView.data.length <= 0) this.gridView.data = x.Data;
          this.aggregatesInfo = x.AggregatesInfo;
          this.isPageSizes = x.TotalPage > this.state.skip;
          this.isRefreshing = false;
          if (this.loadAllData && this.exportKind !== undefined && this.exportKind.toLocaleUpperCase() === "PDF") {
            this.grid.saveAsPDF();
          }
          if (this.loadAllData && this.exportKind !== undefined && this.exportKind.toLocaleUpperCase() === "EXCEL") {
            this.saveAsExcel();
          }
          this.setGridData();
          this.loadAllData = false;
          this.fitColumns();
          this.cd.markForCheck();
        },
        (error) => {
          this.isRefreshing = false;
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در بارگذاری اطلاعات");
        }
      );
  }
  saveAsExcel() {
    this.grid.saveAsExcel();
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    if (this.onlyDefaultSortKey === true) this.state.sort = undefined;
    this.setDefaultFilterKey();
    this.setDefaultSortKey();
    ///به خاطر رفع اشکال سورتینگ اشخاص
    if (this.state.sort.length > 1) this.removeDefaultSortKey();
    if (this.paging && (!this.dataList || this.dataList.length <= 0) && !this.noToolBar && this._gridViewData === undefined) {
      this.filterChange();
    } else {
      var filters: GridFilter[] = this.getGridFilter();
      if (!filters) filters = [];
      if (filters.length <= 0) {
        filters.push({ Type: "S", Filed: "", Operator: "asc", Value: 0, Skip: this.state.skip, Take: this.state.take });
      }
      if (this._gridViewData !== undefined || this.noToolBar === true) this.onDataStateChanged.emit(filters);
      else this.refreshData();
    }
  }
  getmodelName(name: string) {
    var modelName = this.columns.find((x) => x.name === name);
    if (modelName && modelName.modelName) return modelName.modelName;
    return name;
  }
  getGridFilter(): GridFilter[] {
    //this._filters = [];
    var tempFilters: GridFilter[] = this.filters ? Object.assign([], this.filters) : [];
    if (tempFilters.length > 0) {
      tempFilters.forEach((x) => {
        x.Skip = !this.loadAllData ? this.state.skip : 0;
        x.Take = !this.loadAllData ? this.state.take : 10000;
      });
    }

    if (this.state.filter) {
      this.state.filter.filters.forEach((x: FilterDescriptor | any) => {
        if (x.filters) {
          x.filters.forEach((x2: FilterDescriptor | any) => {
            x2.value = typeof x.value === "string" ? CorrectYeKeService.getCorrectYeKe(x2.value) : x2.value;
            let temp: GridFilter = {
              Type: "F",
              Filed: this.getmodelName(x2.field),
              Operator: x2.operator,
              Value: x2.value,
              Skip: !this.loadAllData ? this.state.skip : 0,
              Take: !this.loadAllData ? this.state.take : 10000,
              Logic: x.logic,
            };
            if (!tempFilters.some((f) => f.Filed === temp.Filed && f.Type === temp.Type)) tempFilters.push(temp);
          });
        } else {
          x.value = typeof x.value === "string" ? CorrectYeKeService.getCorrectYeKe(x.value) : x.value;
          let temp: GridFilter = {
            Type: "F",
            Filed: this.getmodelName(x.field),
            Operator: x.operator,
            Value: x.value,
            Skip: !this.loadAllData ? this.state.skip : 0,
            Take: !this.loadAllData ? this.state.take : 10000,
            Logic: this.state.filter.logic,
          };
          if (!tempFilters.some((f) => f.Filed === temp.Filed && f.Type === temp.Type)) tempFilters.push(temp);
        }
      });
    }
    if (this.state.group) {
      this.state.group.forEach((x: GroupDescriptor) => {
        let temp2: GridFilter = {
          Type: "S",
          Filed: this.getmodelName(x.field),
          Operator: "asc",
          Value: 0,
          Skip: !this.loadAllData ? this.state.skip : 0,
          Take: !this.loadAllData ? this.state.take : 10000,
        };
        if (!tempFilters.some((f) => f.Filed === temp2.Filed && f.Type === temp2.Type)) tempFilters.push(temp2);
      });
    }
    if (this.state.sort) {
      this.state.sort
        .filter((x) => x.dir !== undefined)
        .forEach((x: SortDescriptor) => {
          let temp2: GridFilter = {
            Type: "S",
            Filed: this.getmodelName(x.field),
            Operator: x.dir,
            Value: 0,
            Skip: !this.loadAllData ? this.state.skip : 0,
            Take: !this.loadAllData ? this.state.take : this.gridView.total,
          };
          if (!tempFilters.some((f) => f.Filed === temp2.Filed && f.Type === temp2.Type)) tempFilters.push(temp2);
        });
    }

    return tempFilters;
  }
  async filterChange() {
    if ((this.isRefreshing || !this.apiName) && !this.aggregatesColumnName) {
      if (this.aggregatesColumnName) setTimeout((x) => this.filterChange(), 100);
      return;
    }

    this.setAggregates();
    var filters: GridFilter[] = this.getGridFilter();
    filters.forEach((x) => {
      if (this.persianService.isPersianNumber(x.Value)) x.Value = this.persianService.toEnglishNumber(x.Value);
    });
    if ((filters !== null && filters.length > 0) || this._filters || this.apiName.split("/").length > 1) {
      this.isRefreshing = true;
      let gridFilters: string = this.apiName?.split("/").length <= 1 ? "/GetFilterGrid" : "";
      await this._httpCommonService
        .GetFilterGrid<any>(this.apiName + gridFilters, filters)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then(
          (x: PagingDataResult<any>) => {
            const data = ((x?.Data ?? x) as any[]) || [];
            this.isPageSizes = !this.loadAllData;
            this.isRefreshing = false;
            this.gridView = process(data, { group: this.state.group, sort: this.state.sort, filter: this.state.filter });
            this.gridView.total = x?.TotalPage ?? data.length;
            if (this.gridView.data.length <= 0) this.gridView.data = data;
            this.aggregatesInfo = x?.AggregatesInfo;
            this.isPageSizes = x?.TotalPage > this.state.take;
            this.setGridData();
            if (this.loadAllData && this.exportKind !== undefined && this.exportKind.toLocaleUpperCase() === "PDF") {
              this.grid.saveAsPDF();
            }
            if (this.loadAllData && this.exportKind !== undefined && this.exportKind.toLocaleUpperCase() === "EXCEL") {
              this.saveAsExcel();
            }
            this.isPageSizes = !this.loadAllData;
            this.loadAllData = false;
            if (this.gridView.total === data.length) {
              this.state.skip = 0;
              this.onGetDataComplete.emit(this.gridView.data);
              ///بابت ایجاد مشکل بعد از فیلتر کردن و نمایش تعداد رکورد به تعداد فیلتر شده
              //this.state.take = this.gridView.total;
            }
            this.fitColumns();

            of(null)
              .pipe(delay(50), take(1))
              .subscribe(() => {
                this.cd.markForCheck();
                if (x?.Data && this.grid && this.grid.data["total"] !== x?.TotalPage) this.grid.data["total"] = x?.TotalPage;
                if ((x?.Data && this.grid && !this.grid.data["data"]) || this.grid.data["data"]?.length <= 0) this.grid.data["data"] = data;
                if (
                  x &&
                  data &&
                  x?.TotalPage > 0 &&
                  this.grid &&
                  (!this.grid.data["total"] || this.grid.data["total"] <= 0 || this.grid.data["total"] < this.gridView.total)
                ) {
                  if (this.refreshingTime <= 2) this.refreshingTime++;
                  this.filterChange();
                }
              });
          },
          (error) => {
            console.log("GridError");
            console.log(error);
            this.isRefreshing = false;
            if (
              Utilities.getHttpResponseMessage(error).includes(
                "A second operation was started on this context instance before a previous operation completed."
              ) &&
              this.refreshingTime <= 2
            ) {
              this.refreshingTime++;
              this.filterChange();
              return;
            }
            this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در بارگذاری اطلاعات");
          }
        );
    } else await this.loadItems();
  }
  setAggregates() {
    if (!this.aggregatesColumnName) return;
    if (!this._filters) this._filters = [];
    var keys = this.aggregatesColumnName?.split(",");
    keys.forEach((x) => {
      let pluskey = x?.split("_");
      if (pluskey.length <= 1) {
        if (!this._filters.some((a) => a.Filed === x))
          this._filters.push(<GridFilter>{ Type: "A", Filed: x, Value: "sum", Operator: "eq", Skip: this.state.skip, Take: this.state.take });
      } else {
        pluskey.forEach((p) => {
          if (!this._filters.some((a) => a.Filed === p))
            this._filters.push(<GridFilter>{ Type: "A", Filed: p, Value: "sum", Operator: "eq", Skip: this.state.skip, Take: this.state.take });
        });
      }
    });
  }
  public addHandler({ sender }) {
    var datatrasfer: Datatransfer = <Datatransfer>{};
    datatrasfer.apiName = this.apiName;
    datatrasfer.label = this.label;
    datatrasfer.areaName = this.areaName;
    if (this.noToolBar || this.editFromForm) {
      this.onCreate.emit(null);
      return;
    }
    if (this.isModal) {
      this.modalIsLoaded = true;
      this.dialogService
        .open(
          this.inputEditorform,
          {
            currentrow: null,
            apiName: this.apiName,
            areaName: this.areaName,
            label: this.label,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {
          setTimeout(() => this.refreshData(), 200);
        });
    } else {
      const menu = <ITab>{
        title: `${this.label}(ایجاد)`,
        isCloseable: true,
        icon: this.icon,
        active: true,
        responsive: true,
        componentType: this.inputEditorform,
        //modulePath: this.isModal ? this.getCurrentTabInfo()?.modulePath : null,
        data: [
          { provide: EntityBase, useValue: null },
          { provide: Datatransfer, useValue: datatrasfer },
          { provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: null } },
        ],
      };
      this.tabsservice.open(menu);
    }
  }

  onHeaderSave() {
    if (document.hidden) return;
    if (this.dialogIsloaded) return;

    this.onSave.emit();
  }
  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl("#/", { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  public editHandler({ sender, rowIndex, dataItem }) {
    var datatrasfer: Datatransfer = <Datatransfer>{};
    datatrasfer.apiName = this.apiName;
    datatrasfer.label = this.label;
    datatrasfer.areaName = this.areaName;
    datatrasfer.currentrow = dataItem;
    if (this.noToolBar || this.editFromForm) {
      this.onEdit.emit(dataItem);
      return;
    }
    if (this.isModal) {
      this.modalIsLoaded = true;
      this.dialogService
        .open(
          this.inputEditorform,
          {
            currentrow: dataItem,
            apiName: this.apiName,
            areaName: this.areaName,
            label: this.label,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {
          let isLoading: boolean = false;
          if (this.apiName === "Role" && this.areaName === "General") {
            const x = this.accountService.authService.userRoles(this.accountService.authService.currentUser.UserName);
            if (x && x.length > 0 && !isLoading && x.some((f) => f.Id === dataItem["Id"])) {
              isLoading = true;
              this.accountService.authService.menuIsRefreshed.next(true);
            }
          }
          setTimeout(() => this.refreshData(), 200);
        });
    } else {
      const menu = <ITab>{
        title: `${this.label}-(ویرایش)`,
        isCloseable: true,
        icon: this.icon,
        active: true,
        responsive: true,
        componentType: this.inputEditorform,
        //modulePath: this.isModal ?  this.getCurrentTabInfo().modulePath : null,
        data: [
          { provide: EntityBase, useValue: dataItem },
          { provide: Datatransfer, useValue: datatrasfer },
          { provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: dataItem[this.VoucherKindIdName] } },
        ],
      };
      this.tabsservice.open(menu);
    }
  }
  deleteList: number[] = [];
  public removeHandler({ dataItem }): void {
    try {
      if (this.IgnoreDeletePermission) {
        if (this.deleteMessage != "") {
          this.sts.showDialog(this.deleteMessage, "توجه");
          return;
        } else {
          this.sts.showDialog("حذف ممکن نیست", "توجه");
          return;
        }
      }
      if (this.noToolBar || this.useCustomDelete) {
        this.onDelete.emit(dataItem);
        return;
      }
      this.deleteList = [];
      Object.assign(this.deleteList, this.selectedRows);
      let message =
        this.isMultiDelete && this.deleteList.length > 1
          ? `شما با این کار کلیه اطلاعات  انتخاب شده را حذف خواهید کرد و به هیچ عنوان امکان بازیابی اطلاعات را ندارید. آیا از حذف همه اطلاعات انتخاب شده اطمینان دارید؟`
          : `آیا از حذف اطلاعات اطمینان دارید؟`;
      this.sts.showDialog(message, "حذف اطلاعات", DialogType.confirm, () => this.deleteFormHelper(dataItem));
    } catch (e) {
      console.log(e);
      return;
    }
  }
  async deleteFormHelper(row: any) {
    this.sts.showToast("primary", "", "در حال حذف...");
    if (this.isMultiDelete && this.deleteList && this.deleteList.length > 1) {
      let list = this.gridView.data.filter((x) => this.deleteList.some((s) => s["Id"] === x.Id));
      if (this.apiName === "AccVoucherHeader" && list.some((x) => (x && x.AccVoucherKindCode > 1) || x.SystemKindCode != SystemKind.ACC)) {
        this.sts.showToast("primary", "", "شما مجاز به حذف اسناد نمی باشید.");
        return;
      }
      if (this.apiName === "InvVoucherHeader" && list.some((x) => x && x.IsTakingOfInventory === true)) {
        this.sts.showToast("primary", "", "شما مجاز به حذف اسناد نمی باشید.");
        return;
      }
      await this._httpCommonService
        .bulkDelete(this.apiName.split("/")[0], list)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then(
          (results) => {
            this.sts.showToast("success", "", "اطلاعات با موفیت حذف شد.");
            this.rowsCache = this.rowsCache.filter((item) => item !== row);
            setTimeout(() => this.refreshData(), 200);
          },
          (error) => {
            this.isRefreshing = false;
            setTimeout(() => this.refreshData(), 200);
            this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در حذف اطلاعات");
          }
        );
    } else {
      let list = this.gridView.data.filter((x) => this.deleteList.some((s) => s === x.Id));
      if (this.apiName === "AccVoucherHeader" && list.some((x) => (x && x.AccVoucherKindCode > 1) || x.SystemKindCode != SystemKind.ACC)) {
        this.sts.showToast("primary", "", "شما مجاز به حذف اسناد نمی باشید.");
        return;
      }
      if (this.apiName === "InvVoucherHeader" && list.some((x) => x && x.IsTakingOfInventory === true)) {
        this.sts.showToast("primary", "", "شما مجاز به حذف اسناد نمی باشید.");
        return;
      }
      await this._httpCommonService
        .delete(this.apiName?.split("/")[0], row.Id)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then(
          (results) => {
            this.sts.showToast("success", "", "اطلاعات با موفیت حذف شد.");
            this.rowsCache = this.rowsCache.filter((item) => item !== row);
            this.refreshData();
            this.onDeleteCompleted.emit(true);
          },
          (error) => {
            this.onDeleteCompleted.emit(false);
            this.isRefreshing = false;
            this.refreshData();
            this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در حذف اطلاعات");
          }
        );
    }
  }
  onrowSelect($event) {
    if (document.hidden) return;
    this.SelectRow = Object.assign({}, $event.data);
    this.dialogIsloaded = false;
    this.onRowSelected.emit(this.SelectRow);
  }
  onToolbarItemClick(action: EntityListAction) {
    if (document.hidden) return;
    if (this.dialogIsloaded) return;
    if (action.isModal === undefined) action.isModal = true;
    if (action.requireSelectedrows && !this.SelectRow && (!this.selectedRows || this.selectedRows.length === 0)) {
      this.sts.showDialog("هیچ قلمی انتخاب نشده است.", "پیغام خطا");
      this.dialogIsloaded = true;
      return;
    }

    this.dialogIsloaded = false;
    if (!this.SelectRow && this.selectedRows.length > 0) this.SelectRow = Object.assign({}, this.selectedRows[0]);

    if (this.actionTregger && !action.disabled) {
      this.actionTregger(action, this.SelectRow, this.selectedRows, this.selectAllState === "checked", this.getGridFilter());
      return;
    }
    if (this.SelectRow && (!this.selectedRows || this.selectedRows.length <= 0)) {
      this.selectedRows = [];
      this.selectedRows.push(this.SelectRow);
      this.onRowsSelected.emit(this.selectedRows);
    }

    var datatrasfer: Datatransfer = <Datatransfer>{};
    datatrasfer.apiName = action.apiName;
    datatrasfer.label = this.label;
    datatrasfer.areaName = action.areaName;
    datatrasfer.currentrow = this.SelectRow;
    if (datatrasfer?.currentrow && datatrasfer?.currentrow["AccVoucherHeaderId"] === 0 && action.apiName.includes("AccVoucherHeader")) {
      this.sts.showDialog("سند حسابداری پیدا نشد/صادر نشده است.", "پیغام خطا");
      return;
    }
    if (action.isModal) {
      this.dialogService
        .open(
          action.Form_Component,
          {
            currentrow: this.SelectRow,
            apiName: action.apiName,
            isModal: action.isModal,
            areaName: action.areaName,
            label: this.label,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {
          setTimeout(() => this.refresh_Data(), 200);
        });
    } else {
      const menu = <ITab>{
        title: `${this.label}-(ویرایش)`,
        isCloseable: true,
        icon: this.icon,
        active: true,
        responsive: true,
        componentType: action.Form_Component,
        //modulePath: this.isModal ? this.getCurrentTabInfo().modulePath:null,
        data: [
          { provide: EntityBase, useValue: this.SelectRow },
          { provide: Datatransfer, useValue: datatrasfer },
          { provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: this.SelectRow[this.VoucherKindIdName] } },
        ],
      };
      this.tabsservice.open(menu);
    }
  }
  onGridSelectionChange(event: SelectionEvent) {
    if (this.isMulti) {
      event.selectedRows.forEach((x) => {
        if (!this.selectedRows.some((s) => s.Id === x.dataItem.Id)) this.selectedRows.push(x.dataItem);
      });
    }
    this.dialogIsloaded = false;
  }
  async saveGridColumnInfo() {
    if (this.VoucherKindId < 0) this.VoucherKindId = this.VoucherKindId * -1;
    if (!this.apiName && !this.name) return;
    const list: GridColumnInfoDetail[] = [];
    if (this.grid && this.grid.columns) {
      this.grid.columns.forEach((x: ColumnComponent) => {
        if (x) {
          const column = new GridColumnInfoDetail();
          column.leaftindex = x.leafIndex;
          column.orderindex = x.orderIndex;
          column.hidden = x.hidden;
          column.name = x.field ?? x.title;
          column.width = x.width;
          column.minResizableWidth = x.minResizableWidth;
          column.title = x.title;
          list.push(column);
        }
      });
      if (!this._GridColumnInfo) this._GridColumnInfo = new GridColumnInfo();
      this._GridColumnInfo.Key = this.VoucherKindId ? `${this.name}_${this.VoucherKindId}` : this.name;
      this._GridColumnInfo.ColumnInfo = JSON.stringify(list);
      this._GridColumnInfo.CreatedUserId = this.accountService.authService.currentUser.Id;
      if (this.state.group && this.state.group.length > 0) this._GridColumnInfo.Group = JSON.stringify(this.state.group);
      else this._GridColumnInfo.Group = undefined;
      await this._httpCommonService.updateItem("MisSetUp/UpdateGridColumnInfo", this._GridColumnInfo).pipe(takeUntil(this.ngUnsubscribe)).toPromise();
    }
  }
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    this.validActions = undefined;
    this.actions = undefined;
    this.saveGridColumnInfo();
    this.columns = undefined;
    this._filters = undefined;
    this.grid = undefined;
    this._dataList = undefined;
    this._GridColumnInfo = undefined;
    this.reportList = undefined;
    this.mySelection = undefined;
    this.selectAllState = undefined;
    this.loadAllData = undefined;
    this.FormControlTypes = undefined;
    this.rowsCache = undefined;
    this.selectedRows = undefined;
    this.inputEditorform = undefined;
    this.SelectRow = undefined;
  }
  public exportToPDF(grid: GridComponent): void {
    this.grid = grid;
    this.loadAllData = true;
    this.exportKind = "PDF";
    if (this.paging) this.filterChange();
    else {
      this.grid.saveAsPDF();
      this.loadAllData = false;
    }
  }
  public async exportToExcel(grid: GridComponent) {
    if (this.customExportExcelUrl) {
      let params = await this.getParamsForExportExcelWithPostMethod();
      this.splashFormService.openDialog("در حال دانلود اکسل..");
      this._httpCommonService
        .getExcel(this.customExportExcelUrl, params)
        .pipe(take(1))
        .toPromise()
        .then(
          (response: any) => {
            this.downloadExcelFile(response);
            this.splashFormService.closeLoading();
          },
          (error) => {
            this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)} `, "خطا در دانلود اکسل");
            this.splashFormService.closeLoading();
          }
        );
      return;
    }
    this.grid = grid;
    this.loadAllData = true;
    this.exportKind = "EXCEL";
    if (this.paging) this.filterChange();
    else {
      this.saveAsExcel();
      this.loadAllData = false;
    }
  }

  downloadExcelFile(response: any): void {
    let contentDisposition = response.headers.get("Content-Disposition");
    let filename = "";
    if (contentDisposition) {
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(contentDisposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, "");
      }
    }

    if (!filename && this.reportName) {
      filename = this.reportName;
    }

    let dataType = response.body.type;
    let binaryData = [];
    binaryData.push(response.body);
    let downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
    if (filename) downloadLink.setAttribute("download", filename);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  public onRowClick(event): void {
    if (document.hidden) return;
    this.SelectRow = Object.assign({}, event?.dataItem);
    this.dialogIsloaded = false;
    this.onRowSelected.emit(this.SelectRow);
    if (this.isMulti) this.onRowsSelected.emit([this.SelectRow]);
  }

  public onDblClick(_e): void {
    if (this.SelectRow) {
      this.onDoubleClick.emit(this.SelectRow);
      if (!this.disableOnDoubleClick && this.isEdit) this.editHandler({ sender: undefined, rowIndex: 0, dataItem: this.SelectRow });
    }
  }

  public colorCode(code: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(code);
  }
  getFilterParameter(key: string, operator: string) {
    return this._filters?.find((x) => x.Filed === key && x.Operator === operator)?.Value;
  }
  changeReport(reprtName: string) {
    if (!this.pathPreFix) this.pathPreFix = "GNR";
    let saveReportFile: SaveReportFile = <SaveReportFile>{};
    saveReportFile.ReportTitle = this.label;
    saveReportFile.FileName = this.reportName;
    saveReportFile.SystemKindName = this.pathPreFix;
    saveReportFile.CategoryName = this.apiName.replace("/", "_");
    this.sts.showToast("success", "", "اطلاعات با موفقیت بارگذاری شد.");
    if (this.reportList && this.reportList.length > 1) {
      this.dialogService
        .open(
          ReportSelectorComponent,
          {
            dataList: this.reportList,
            currentrow: null,
            apiName: this.apiName,
            areaName: this.areaName,
            label: "انتخاب گزارش",
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: any) => {
          if (model) {
            this.setReport(reprtName, model);
          }
        });
      return;
    }
    if (this.reportList && this.reportList.length === 1) {
      saveReportFile = this.reportList[0];
    } else {
      this.reportList = [];
      this.reportList.push(saveReportFile);
      this.saveCurrentReport(saveReportFile, this.apiName, [] as any[]);
      setTimeout(() => this.loadReports(), 1000);
    }
    this.setReport(reprtName, saveReportFile);
  }
  saveCurrentReport(saveReportFile: SaveReportFile, apiName: string, dataList: any[]) {
    let reportInfo: ReportInfo = <ReportInfo>{};
    reportInfo.reportKind = ReportKind.saveReport;
    reportInfo.apiName = apiName;
    reportInfo.reportName = saveReportFile.FileName;
    reportInfo.dataList = dataList;
    reportInfo.saveReportFile = saveReportFile;
    const menu = <ITab>{
      title: `(${saveReportFile.ReportTitle}) در حال ذخیره گزارش`,
      isCloseable: true,
      active: true,
      responsive: true,
      componentType: StimulSoftReportComponent,
      data: [{ provide: ReportInfo, useValue: reportInfo }],
    };
    this.tabsservice.open(menu);
  }
  async setReport(reprtName: string, saveReportFile: SaveReportFile) {
    if (reprtName === "deleteReport") {
      this.sts.showDialog(`آیا از حذف گزارش اطمینان دارید؟`, "حذف گزارش", DialogType.confirm, () => this.deleteReport(saveReportFile));
      return;
    }

    if (this.dataList && this.dataList.length > 0) {
      if (reprtName === "print") this.print(saveReportFile, this.apiName, this.dataList);
      if (reprtName === "preview") this.preview(saveReportFile, this.apiName, this.dataList);
      if (reprtName === "editReport") this.editReport(saveReportFile, this.apiName, this.dataList);
      if (reprtName === "copyReport") this.copyReport(saveReportFile, this.dataList);
    } else if ((this._filters && this._filters.length > 0) || this.apiName.split("/").length > 1) {
      if (!this._filters || this._filters.length <= 0) {
        var keys = this.defaultSortKey?.split(",");
        this._filters = [];
        if (keys) this._filters.push(<GridFilter>{ Type: "S", Filed: this.getmodelName(keys[0]), Value: 0, Operator: "eq" });
      }
      let gridFilters: string = this.apiName?.split("/").length <= 1 ? "/GetFilterGrid" : "";
      this._filters.forEach((x) => (x.Take = 1000));
      await this._httpCommonService
        .GetFilterGrid<any>(this.apiName + gridFilters, this._filters)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then(
          (x: PagingDataResult<any>) => {
            if (x && x.Data !== undefined) {
              this.sts.showToast("success", "", "اطلاعات با موفقیت بارگذاری شد.");
              if (reprtName === "print") this.print(saveReportFile, this.apiName, x.Data as any[]);
              if (reprtName === "preview") this.preview(saveReportFile, this.apiName, x.Data as any[]);
              if (reprtName === "editReport") this.editReport(saveReportFile, this.apiName, x.Data as any[]);
              if (reprtName === "copyReport") this.copyReport(saveReportFile, x.Data as any[]);
            }
          },
          (error) => {
            this.isRefreshing = false;
            this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در بارگذاری اطلاعات");
          }
        );
    } else if (!this.noToolBar) {
      if (this.showLoadingMessage) this.sts.showToast("primary", "", "در حال بارگذاری اطلاعات...");
      await this._httpCommonService
        .getList(this.apiName)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then(
          (_data) => {
            if (_data !== undefined) {
              this.sts.showToast("success", "", "اطلاعات با موفقیت بارگذاری شد.");
              if (reprtName === "print") this.print(saveReportFile, this.apiName, _data as any[]);
              if (reprtName === "preview") this.preview(saveReportFile, this.apiName, _data as any[]);
              if (reprtName === "editReport") this.editReport(saveReportFile, this.apiName, _data as any[]);
              if (reprtName === "copyReport") this.copyReport(saveReportFile, _data as any[]);
            }
          },
          (error) => {
            this.isRefreshing = false;
            this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در بارگذاری اطلاعات");
          }
        );
    }
  }
  copyReport(saveReportFile: SaveReportFile, dataList: any[]) {
    let inputEditorform: Type<any> = ReportCopyComponent;
    this.dialogService
      .open(
        inputEditorform,
        {
          currentrow: null,
          apiName: this.apiName,
          areaName: this.areaName,
          label: "تکثیر گزارش",
          hasManageAccess: true,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model: any) => {
        if (model) {
          saveReportFile.ReportTitle = model.ReportTitle;
          saveReportFile.Id = 0;
          this.copyNewReport(saveReportFile, saveReportFile.FileName, this.apiName, dataList);
        }
      });
  }
  async deleteReport(saveReportFile: SaveReportFile) {
    await this._httpCommonService
      .deleteByParameter(this.apiName.split("/")[0] + "/DeleteReportInfo/?id=" + saveReportFile.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (results) => {
          this.sts.showToast("success", "", "گزارش با موفیت حذف شد.");
          setTimeout(() => this.loadReports(), 200);
        },
        (error) => {
          this.isRefreshing = false;
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در حذف گزارش");
        }
      );
  }

  public onColumnVisibilityChange(e: ColumnVisibilityChangeEvent) {
    e.columns.forEach((c) => {
      const column = this.columns.find((x) => x.name == c["field"]);
      if (column) column.listVisible = !c.hidden;
    });
  }

  print(saveReportFile: SaveReportFile, apiName: string, dataList: any[]) {
    let reportInfo: ReportInfo = <ReportInfo>{};
    reportInfo.reportKind = ReportKind.print;
    reportInfo.apiName = apiName;
    reportInfo.reportName = saveReportFile.FileName;
    reportInfo.DataSourceName = saveReportFile.DataSourceName;
    reportInfo.dataList = dataList;
    reportInfo.saveReportFile = saveReportFile;
    reportInfo.filterText = this.filterText;
    reportInfo.startDate = this.getFilterParameter("VoucherDate", "gte");
    reportInfo.endDate = this.getFilterParameter("VoucherDate", "lte");
    reportInfo.startNumber = this.getFilterParameter("VoucherNo", "gte");
    reportInfo.endNumber = this.getFilterParameter("VoucherNo", "lte");
    reportInfo.includeTime = this.getFilterParameter("IncludeTime", "eq");
    const menu = <ITab>{
      title: saveReportFile.ReportTitle,
      isCloseable: true,
      active: true,
      responsive: true,
      componentType: StimulSoftReportComponent,
      data: [{ provide: ReportInfo, useValue: reportInfo }],
    };
    this.tabsservice.open(menu);
  }
  preview(saveReportFile: SaveReportFile, apiName: string, dataList: any[]) {
    let reportInfo: ReportInfo = <ReportInfo>{};
    reportInfo.reportKind = ReportKind.preview;
    reportInfo.apiName = apiName;
    reportInfo.reportName = saveReportFile.FileName;
    reportInfo.DataSourceName = saveReportFile.DataSourceName;
    reportInfo.dataList = dataList;
    reportInfo.saveReportFile = saveReportFile;
    reportInfo.filterText = this.filterText;
    reportInfo.startDate = this.getFilterParameter("VoucherDate", "gte");
    reportInfo.endDate = this.getFilterParameter("VoucherDate", "lte");
    reportInfo.startNumber = this.getFilterParameter("VoucherNo", "gte");
    reportInfo.endNumber = this.getFilterParameter("VoucherNo", "lte");
    reportInfo.includeTime = this.getFilterParameter("IncludeTime", "eq");
    if (!this.pathPreFix) this.pathPreFix = "GNR";
    reportInfo.pathPreFix = this.pathPreFix;
    const menu = <ITab>{
      title: saveReportFile.ReportTitle,
      isCloseable: true,
      active: true,
      responsive: true,
      componentType: StimulSoftReportComponent,
      //modulePath: this.getCurrentTabInfo()?.modulePath,
      data: [{ provide: ReportInfo, useValue: reportInfo }],
    };
    this.tabsservice.open(menu);
  }
  editReport(saveReportFile: SaveReportFile, apiName: string, dataList: any[]) {
    let reportInfo: ReportInfo = <ReportInfo>{};
    reportInfo.reportKind = ReportKind.editReport;
    reportInfo.apiName = apiName;
    reportInfo.reportName = saveReportFile.FileName;
    reportInfo.DataSourceName = saveReportFile.DataSourceName;
    reportInfo.reportTitle = this.label;
    reportInfo.dataList = dataList;
    reportInfo.filterText = this.filterText;
    reportInfo.startDate = this.getFilterParameter("VoucherDate", "gte");
    reportInfo.endDate = this.getFilterParameter("VoucherDate", "lte");
    reportInfo.startNumber = this.getFilterParameter("VoucherNo", "gte");
    reportInfo.endNumber = this.getFilterParameter("VoucherNo", "lte");
    reportInfo.includeTime = this.getFilterParameter("IncludeTime", "eq");
    if (!this.pathPreFix) this.pathPreFix = "GNR";
    reportInfo.pathPreFix = this.pathPreFix;
    reportInfo.saveReportFile = saveReportFile;
    const menu = <ITab>{
      title: saveReportFile.ReportTitle,
      isCloseable: true,
      active: true,
      responsive: true,
      componentType: StimulSoftReportComponent,
      data: [{ provide: ReportInfo, useValue: reportInfo }],
    };
    this.tabsservice.open(menu);
  }
  copyNewReport(saveReportFile: SaveReportFile, oldReportName: string, apiName: string, dataList: any[]) {
    let reportInfo: ReportInfo = <ReportInfo>{};

    reportInfo.reportKind = ReportKind.editReport;
    reportInfo.apiName = apiName;
    saveReportFile.FileName = `${this.reportName}_${this.reportList.length}`;
    reportInfo.reportTitle = this.label;
    reportInfo.dataList = dataList;
    reportInfo.oldReportName = oldReportName;
    if (!this.pathPreFix) this.pathPreFix = "GNR";
    reportInfo.pathPreFix = this.pathPreFix;
    reportInfo.saveReportFile = saveReportFile;
    const menu = <ITab>{
      title: saveReportFile.ReportTitle,
      isCloseable: true,
      active: true,
      responsive: true,
      componentType: StimulSoftReportComponent,
      data: [{ provide: ReportInfo, useValue: reportInfo }],
    };
    this.tabsservice.open(menu);
  }
  getCurrentTabInfo() {
    return this.tabsservice.getActiveTab();
  }

  getColumnAggregates(columnName: string) {
    let pluskey = columnName.split("_");
    if (pluskey.length <= 1) {
      if (this.aggregatesInfo && this.aggregatesInfo.length > 0) return this.aggregatesInfo.find((x) => x.ColumnName === columnName).Value;
    } else {
      if (this.aggregatesInfo && this.aggregatesInfo.length > 0)
        return (
          this.aggregatesInfo.find((x) => x.ColumnName === pluskey[0]).Value + this.aggregatesInfo.find((x) => x.ColumnName === pluskey[1]).Value
        );
    }
    return undefined;
  }
  hasAggregate(columnName: string) {
    return this.aggregatesColumnName !== undefined && this.aggregatesColumnName.includes(columnName);
  }
  isGrouped(filed: string) {
    return this.state && this.state.group && this.state.group.some((x) => x.field === filed);
  }
  clearFilter() {
    this.state.filter.filters = [];
    this.grid.filter = { logic: "and", filters: [] };
    this.setDefaultFilterKey();
    var filters: GridFilter[] = this.getGridFilter();
    if (!filters) filters = [];
    if (this._gridViewData !== undefined) this.onDataStateChanged.emit(filters);
    else this.refreshData();
  }
  getMaskedAmount(amount: number, inputMask: string) {
    if (inputMask === "000:00") {
      let temp: number = amount % 60;
      let MM = (amount - temp) / 60;
      return "0".repeat(3 - MM.toString().length) + MM + ":" + "0".repeat(2 - temp.toString().length) + temp;
    }
    if (inputMask === "00:00:00") {
      let temp1: number = amount % 440;
      let temp2: number = temp1 % 60;
      let DD = (amount - temp1) / 440;
      let MM = (temp1 - temp2) / 60;
      return (
        "0".repeat(2 - DD.toString().length) +
        DD +
        ":" +
        "0".repeat(2 - MM.toString().length) +
        MM +
        ":" +
        "0".repeat(2 - temp2.toString().length) +
        temp2
      );
    }
    if (inputMask === "00:00") return "0".repeat(2 - amount.toString().length) + amount;

    return amount;
  }

  filterChanges(event: any) {
    if (this.apiName) return;
    this.dataList = JSON.parse(JSON.stringify(this.dataList));
  }

  copy() {
    if (!this.SelectRow) {
      this.sts.showToast("danger", "خطا", "کپی با خطا مواجه شد");
      return;
    }

    try {
      let row = { ...this.SelectRow };
      this.preCopy.emit(row);
      this.gridView.data.push(row);
    } catch (error) {
      this.sts.showToast("danger", "خطا", "کپی با خطا مواجه شد");
    }
  }
  @Output() preCopy = new EventEmitter();
}
